import { Dayjs } from 'dayjs'

const formatDate = (date: Dayjs | null | undefined, fallback?: Dayjs): string => {
  return date?.format('YYYY-MM-DD') || fallback?.format('YYYY-MM-DD') || ''
}

export default formatDate
